import styled from "@emotion/styled";
import { Box } from "@mui/material";

export const StyledChip = styled(Box)`
  height: 34px;
  min-width: 70px;
  width: max-content;
  border-radius: 8px;
  background-color: rgb(8, 16, 55);
  display: flex;
  align-items: center;
  padding: 0 12px;
`;
